query Identity {
  identity {
    user {
      id
      email
      firstname
      lastname
      gender
      isContractOwner
      createdAt
      role {
        id
        name
        slug
        permissions
      }
      appLocale
    }
    company {
      id
      name
      slug
      country
      productType
      platform
      mailProvider
    }
  }
}
